import { useEffect } from "react";
import { useRealtimeChannel } from "./useRealtimeChannel";

type EventType = "INSERT" | "UPDATE" | "DELETE";

type Params<T> = {
  tripId: string | null;
  table: string;
  setItems?: React.Dispatch<React.SetStateAction<T[]>>;
  getId?: (item: T) => string;
  transform?: (items: T[]) => T[];
  onRefresh?: () => void; // 🆕 statt lokale Logik
};

export function useTripRealtimeSync<T>({
  tripId,
  table,
  setItems,
  getId,
  transform,
  onRefresh,
}: Params<T>) {
  const unsubscribe = useRealtimeChannel({
    tripId: tripId || "",
    table,
    onEvent: ({ table: eventTable, event, newData, oldData }) => {
      if (!tripId || eventTable !== table) return;

      if (onRefresh) {
        onRefresh();
        return;
      }

      if (!setItems || !getId) return;

      setItems((prev) => {
        let updated: T[];

        switch (event) {
          case "INSERT": {
            const exists = prev.some((item) => getId(item) === getId(newData));
            updated = exists ? prev : [...prev, newData];
            break;
          }
          case "UPDATE": {
            updated = prev.map((item) =>
              getId(item) === getId(newData) ? newData : item
            );
            break;
          }
          case "DELETE": {
            updated = prev.filter((item) => getId(item) !== getId(oldData));
            break;
          }
          default:
            updated = prev;
        }

        return transform ? transform(updated) : updated;
      });
    },
  });

  useEffect(() => {
    return () => {
      unsubscribe();
    };
  }, [unsubscribe]);
}

